module.exports = __webpack_public_path__ + "static/media/1024-products---5-image-2.432f5788.png";